import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import * as ReactRedux from 'react-redux';
import { CloseSmallIcon } from 'DesignSystem/Icons';
import { IconButton } from 'DesignSystem/Buttons';
import Spinner from 'Spinner';
import SignatureAuditModalRow from './SignatureAuditModalRow';
import styles from '../../sass/main.scss';

const defaultModalStyle = {
  overlay: {
    alignItems: 'center',
    background: styles.modalBackgroundColor,
    display: 'flex',
    justifyContent: 'center',
    zIndex: styles.modalZIndex,
  },
  content: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    bottom: 'unset',
    display: 'flex',
    justifyContent: 'center',
    left: 'unset',
    margin: 0,
    overflow: 'visible',
    position: 'relative',
    right: 'unset',
    top: 'unset',
  },
};

class SignatureAuditModal extends React.PureComponent {
  render() {
    const { isOpen, auditList, isFetchingAuditSessions } = this.props;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this.props.closeModal}
        shouldCloseOnOverlayClick
        style={defaultModalStyle}
      >
        <div className="ds-modal">
          <IconButton
            className="ds-modal-close-icon"
            onClick={this.props.closeModal}
            icon={(<CloseSmallIcon />)}
          />
          <h3>Signature History</h3>
          <div className="table-wrapper">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Email Address</th>
                  <th scope="col">Status</th>
                  <th scope="col">Time</th>
                  <th scope="col">IP Address</th>
                </tr>
              </thead>
              <tbody>
                {auditList.map((auditItem => (
                  <SignatureAuditModalRow auditItem={auditItem} />
                )))}
              </tbody>
            </table>
            {auditList.length === 0 && (
              <div className="no-documents-empty-state">
                {isFetchingAuditSessions ? (
                  <Spinner />
                ) : (
                  <div>
                    You haven&#39;t received any documents with signatures yet.
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

SignatureAuditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isFetchingAuditSessions: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  auditList: PropTypes.arrayOf(PropTypes.shape({
    access_level: PropTypes.string,
    ip_address: PropTypes.string,
    share_email: PropTypes.string,
    share_key: PropTypes.string,
    updated_at: PropTypes.string,
  })).isRequired,
};

const mapStateToProps = ({ SignatureAuditButtonReducer }) => ({
  isFetchingAuditSessions: SignatureAuditButtonReducer.isFetchingAuditSessions,
  auditList: SignatureAuditButtonReducer.auditList,
});

export default ReactRedux.connect(
  mapStateToProps,
)(SignatureAuditModal);



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/SignatureAuditModal.jsx